// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title_3Rla2","typeSelected":"index_typeSelected_3e51r","icon":"index_icon_2I1dJ","wrapper":"index_wrapper_129D6"};